import { createContext, useContext } from "react";
import type { WizardState, WizardAction } from "../state/wizard";

export interface WizardCtx {
  state: WizardState;
  dispatch: (a: WizardAction) => void;
}

export const WizardContext = createContext<WizardCtx | null>(null);

export function useWizardContext(): WizardCtx {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error("WizardContext missing");
  return ctx;
}
